// extracted by mini-css-extract-plugin
module.exports = {"banner":"CookieBanner_banner__x1XxI","button":"CookieBanner_button__Vkm3k"};